// extracted by mini-css-extract-plugin
export default {"content":"YS8nFrOO","desktop":"desktop","commentsButton":"A2BaBOWc","mobile":"mobile","list":"y8aKl_um","item":"NuTgQIwT"};